// import { createSlice } from "@reduxjs/toolkit";
// import userStore from "../zustand/userStore";

// const initialState = {
//   isAuthenticated: false,
//   user: null,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     loginSuccess: (state, action) => {
//       state.isAuthenticated = true;
//       state.user = action.payload;
//       userStore.setState({ user: action.payload });
//     },
//     logout: (state) => {
//       state.isAuthenticated = false;
//       state.user = null;
//     },
//   },
// });

// export const { loginSuccess, logout } = authSlice.actions;
// export default authSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";
import userStore from "../zustand/userStore";
import { loginUserThunk, logoutUserThunk, forceLogoutAllThunk } from "./authThunk";
import { clearAppdAiUser } from "../utils/appdAiHelpers";

const storedUser = localStorage.getItem("userData");
const initialState = {
  user: storedUser ? JSON.parse(storedUser) : null,
  isAuthenticated: !!storedUser,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // loginSuccess: (state, action) => {
    //   const user = action.payload;
    //   state.isAuthenticated = true;
    //   state.user = user;
    //   localStorage.setItem("userData", JSON.stringify(user));
    //   userStore.setState({ user });
    // },
    // logout: (state) => {
    //   state.isAuthenticated = false;
    //   state.user = null;
    //   localStorage.removeItem("userData");
    //   localStorage.removeItem("mdm_org_user");
    //   userStore.setState({ user: null });
    //   localStorage.removeItem("demoAlertShown");
    //   localStorage.removeItem("userToken");
    // },

    handleUserData(state, action) {
      state.user = action.payload;
    },
    setAuthData: (state, action) => {
      const user = action.payload;
      console.log("user_67", user)
      state.user = user.user;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      localStorage.setItem("userData", JSON.stringify(user.user));
      localStorage.setItem("userToken", user.token);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUserThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUserThunk.fulfilled, (state, action) => {
        const user = action.payload;
        state.user = user;
        state.isAuthenticated = true;
        state.loading = false;
        state.error = null;
        localStorage.setItem("userData", JSON.stringify(user.user));
        localStorage.setItem("userToken", user.token);
        // userStore.setState({ user });
      })
      .addCase(loginUserThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutUserThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(logoutUserThunk.fulfilled, (state) => {
        // Clear everything after DB confirms deletion
        state.user = null;
        state.isAuthenticated = false;
        state.loading = false;
        state.error = null;

        localStorage.removeItem("userData");
        localStorage.removeItem("userToken");
        localStorage.removeItem("mdm_org_user");
        localStorage.removeItem("demoAlertShown");
        userStore.setState({ user: null });

        // clearAppdAiUser();
      })
      .addCase(logoutUserThunk.rejected, (state) => {
        state.loading = false;
        // Even if DB hit fails, clear local data so user isn't stuck
        state.user = null;
        state.isAuthenticated = false;
        localStorage.clear();
        userStore.setState({ user: null });
      })
      //For force logout all devices, we can reuse the logout reducers
      .addCase(forceLogoutAllThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forceLogoutAllThunk.fulfilled, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
        state.error = null;

        // Clear all local storage as a security measure
        localStorage.removeItem("userData");
        localStorage.removeItem("userToken");
        localStorage.removeItem("mdm_org_user");
        userStore.setState({ user: null });

        // Note: We don't navigate here; we let the component handle the next login attempt
      })
      .addCase(forceLogoutAllThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { loginSuccess, handleUserData, setAuthData } = authSlice.actions;
export { logoutUserThunk as logout };
export default authSlice.reducer;
